var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from 'react';
import { FormField, Button, Input, InputSelect } from '../../';
import { services } from '../../../../shared/api/services';
import './input-address.scss';
export var InputAddress = function (_a) {
    var _b, _c, _d, _e;
    var register = _a.register, setValue = _a.setValue, errors = _a.errors, watch = _a.watch, value = _a.value, required = _a.required, name = _a.name, disabled = _a.disabled, isReset = _a.isReset;
    var _f = useState(null), addressSelection = _f[0], setAddressSelection = _f[1];
    var _g = useState(null), postCode = _g[0], setPostCode = _g[1];
    var _h = useState(null), addressDetails = _h[0], setAddressDetails = _h[1];
    var _j = useState(true), showPostCodeLookup = _j[0], toggleShowPostCodeLookup = _j[1];
    var _k = useState(false), showManualAddress = _k[0], toggleShowManualAddress = _k[1];
    var _l = useState(), propertyName = _l[0], setPropertyName = _l[1];
    var _m = useState(), propertyNumber = _m[0], setPropertyNumber = _m[1];
    var _o = useState(), road = _o[0], setRoad = _o[1];
    var _p = useState(), town = _p[0], setTown = _p[1];
    var _q = useState(), county = _q[0], setCounty = _q[1];
    var _r = useState(), postcode = _r[0], setPostcode = _r[1];
    var _s = useState('Please enter a valid Post code.'), postcodeError = _s[0], setPostcodeError = _s[1];
    var _t = useState('isInvalid'), isInvalidClass = _t[0], setIsInvalidClass = _t[1];
    var _u = useState(required), isRequiredClass = _u[0], setIsRequiredClass = _u[1];
    var _v = useState(false), isMatchFound = _v[0], setIsMatchFound = _v[1];
    var handleManualAddressView = function () {
        toggleShowPostCodeLookup(!showPostCodeLookup);
        toggleShowManualAddress(!showManualAddress);
    };
    var handleFetchAddressList = function (postCode) { return __awaiter(void 0, void 0, void 0, function () {
        var res, addresses;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getAddressList(postCode.replace(' ', ''), "Postcode")];
                case 1:
                    res = (_a.sent()).data;
                    if (Array.isArray(res) && res.length > 0) {
                        addresses = res.map(function (items) {
                            return { id: items.sid, value: items.itemText };
                        });
                        setAddressSelection(addresses);
                    }
                    else {
                        setIsMatchFound(true);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleFindAddress = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsRequiredClass(true);
                    setAddressSelection(null);
                    setPropertyName(null);
                    setPropertyNumber(null);
                    setRoad(null);
                    setTown(null);
                    setCounty(null);
                    setPostcode(null);
                    toggleShowManualAddress(false);
                    if (postCode == null || postCode == '') {
                        //setIsRequiredClass(true);
                        setAddressSelection(null);
                        setIsInvalidClass('isInvalid');
                        setPostcodeError('Please enter a valid Post code.');
                    }
                    if (!postCode) return [3 /*break*/, 2];
                    return [4 /*yield*/, handleFetchAddressList(postCode)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handlePostCodeEntry = function (e) {
        setIsInvalidClass(null);
        setPostcodeError(null);
        setPostCode(e.currentTarget.value);
    };
    var handleFocusOut = function (event) {
        if (!required) {
            setIsRequiredClass(false);
            setIsInvalidClass(null);
            setPostcodeError(null);
        }
    };
    var formatId = function (id, name) {
        return name ? "".concat(name, "-").concat(id) : id;
    };
    var requiredToggle = watch ? watch([formatId('propertyName', name), formatId('propertyNumber', name)]) : null;
    useEffect(function () {
        setPropertyName(null);
        setPropertyNumber(null);
        setRoad(null);
        setTown(null);
        setCounty(null);
        setPostcode(null);
    }, [isReset]);
    useEffect(function () {
        if (value) {
            services.getAddress(Number(value)).then(function (result) {
                setPropertyName(result.data.propertyName);
                setPropertyNumber(result.data.propertyNumber);
                setRoad(result.data.road);
                setTown(result.data.town);
                setCounty(result.data.county);
                setPostcode(result.data.postCode);
                toggleShowPostCodeLookup(false);
                toggleShowManualAddress(true);
            });
        }
    }, [value]);
    useEffect(function () {
        if (isMatchFound) {
            setAddressSelection(null);
            setIsInvalidClass('isInvalid');
            setPostcodeError("No match found for Post code: ".concat(postCode));
            setIsMatchFound(false);
        }
    }, [isMatchFound]);
    var handleAddressSelection = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var addressDetails, housenameLocal, flatLocal, organisationLocal, addressName;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, services.getAddressDetail(e.currentTarget.value, 'Sid')];
                case 1: return [4 /*yield*/, (_a.sent()).data];
                case 2:
                    addressDetails = _a.sent();
                    setAddressSelection(null);
                    setPropertyName(null);
                    setPropertyNumber(null);
                    setRoad(null);
                    setTown(null);
                    setCounty(null);
                    setPostcode(null);
                    setAddressDetails(addressDetails);
                    toggleShowManualAddress(true);
                    if (addressDetails.houseName2 != null && addressDetails.houseName2 != "") {
                        housenameLocal = addressDetails.houseName2;
                    }
                    else {
                        housenameLocal = "";
                    }
                    if (addressDetails.flat != null && addressDetails.flat != "") {
                        flatLocal = addressDetails.flat + " ";
                    }
                    else {
                        flatLocal = "";
                    }
                    if (addressDetails.organisation != null && addressDetails.organisation != "") {
                        organisationLocal = addressDetails.organisation + " ";
                    }
                    else {
                        organisationLocal = "";
                    }
                    addressName = organisationLocal + flatLocal + housenameLocal;
                    setPropertyName(addressName);
                    setPropertyNumber(addressDetails.houseName1);
                    setRoad(addressDetails.streetName1);
                    setTown(addressDetails.town);
                    setCounty(addressDetails.county);
                    setPostcode(addressDetails.postcode);
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("fieldset", { className: "c-input-address" },
        React.createElement("legend", null, "Address"),
        showPostCodeLookup && (React.createElement(FormField, { id: formatId('postCodeLookup', name), label: "Post code", error: errors[formatId('postCodeLookup', name)] && postcodeError },
            React.createElement("div", { className: "l-flex" },
                React.createElement("div", null,
                    React.createElement("input", { id: formatId('postCodeLookup', name), name: formatId('postCodeLookup', name), className: "c-input ".concat(errors[formatId('postCodeLookup', name)] && isInvalidClass, " ").concat(required && 'isRequired'), type: "text", required: isRequiredClass, "aria-invalid": !!errors.postCodeLookup, ref: register({
                            required: isRequiredClass,
                            validate: isRequiredClass ? function () { return addressDetails !== null; } : null,
                        }), onChange: handlePostCodeEntry, onBlur: handleFocusOut, disabled: disabled })),
                React.createElement("div", null,
                    React.createElement(Button, { type: "submit", name: "findAddressButton", variant: "primary", onClick: handleFindAddress, disabled: disabled }, "Find"))))),
        addressSelection && (React.createElement(FormField, { label: "Select address" },
            React.createElement(InputSelect, { id: "select-address", options: addressSelection, required: false, forceSelection: true, onChange: handleAddressSelection }))),
        !addressDetails && (React.createElement(Button, { type: "button", variant: "bare", childClasses: "u-mb-2", onClick: handleManualAddressView }, showManualAddress ? 'Use Postcode lookup' : 'Enter address manually')),
        showManualAddress && (React.createElement(React.Fragment, null,
            React.createElement(FormField, { id: formatId('propertyName', name), label: "Property name" },
                React.createElement(Input, { id: formatId('propertyName', name), placeHolder: "Property Name", required: requiredToggle ? !(((_b = requiredToggle[formatId('propertyNumber', name)]) === null || _b === void 0 ? void 0 : _b.length) > 0) : true, error: !!errors[formatId('propertyName', name)] && !!errors[formatId('propertyName', name)], ref: register({
                        required: requiredToggle ? !(((_c = requiredToggle[formatId('propertyNumber', name)]) === null || _c === void 0 ? void 0 : _c.length) > 0) : true,
                    }), setValue: setValue, value: propertyName, disabled: disabled })),
            React.createElement(FormField, { id: formatId('propertyNumber', name), label: "Property number", error: errors[formatId('propertyNumber', name)] &&
                    errors[formatId('propertyName', name)] &&
                    'Please enter a property name or number' },
                React.createElement(Input, { id: formatId('propertyNumber', name), placeHolder: "Property Number", required: requiredToggle ? !(((_d = requiredToggle[formatId('propertyName', name)]) === null || _d === void 0 ? void 0 : _d.length) > 0) : true, error: !!errors[formatId('propertyNumber', name)] && !!errors[formatId('propertyName', name)], ref: register({
                        required: requiredToggle ? !(((_e = requiredToggle[formatId('propertyName', name)]) === null || _e === void 0 ? void 0 : _e.length) > 0) : true,
                    }), setValue: setValue, value: propertyNumber, disabled: disabled })),
            React.createElement(FormField, { id: formatId('road', name), label: "Road", error: errors[formatId('road', name)] && 'Please enter a valid road' },
                React.createElement(Input, { id: formatId('road', name), placeHolder: "Road", required: required, error: !!errors[formatId('road', name)], ref: register({ required: required }), setValue: setValue, value: road, disabled: disabled })),
            React.createElement(FormField, { id: formatId('town', name), label: "Town", error: errors[formatId('town', name)] && 'Please enter a valid town' },
                React.createElement(Input, { id: formatId('town', name), placeHolder: "Town", required: required, error: !!errors[formatId('town', name)], ref: register({ required: required }), setValue: setValue, value: town, disabled: disabled })),
            React.createElement(FormField, { id: formatId('county', name), label: "County", error: errors[formatId('county', name)] && 'Please enter a valid county' },
                React.createElement(Input, { id: formatId('county', name), required: false, error: !!errors[formatId('county', name)], placeHolder: "County", ref: register({ required: false }), setValue: setValue, disabled: disabled, value: county })),
            React.createElement(FormField, { id: formatId('postCode', name), label: "Post Code", error: errors[formatId('postCode', name)] && 'Please enter a valid postcode' },
                React.createElement(Input, { id: formatId('postCode', name), placeHolder: "Post Code", required: required, ref: register({ required: required }), error: !!errors[formatId('postCode', name)], setValue: setValue, value: postcode, disabled: disabled }))))));
};
